import { render } from "./IconLink.vue?vue&type=template&id=136b3082"
const script = {}

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__